import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import AudiencePathways from "@/components/AudiencePathways";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import SouthernCalifornia from "@/components/SouthernCalifornia";
import Services from "@/components/Services";
import Network from "@/components/Network";
import CarrierRequirements from "@/components/CarrierRequirements";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#0A0B0E] font-sans text-slate-100 antialiased">
      <Navbar />
      <main>
        <Hero />
        <AudiencePathways />
        <Marquee />
        <About />
        <Services />
        <div id="coverage" data-testid="coverage-section-group" className="scroll-mt-20">
          <SouthernCalifornia />
          <Network />
        </div>
        <CarrierRequirements />
        <Contact />
      </main>
      <Footer />
      <Toaster position="bottom-right" theme="dark" />
    </div>
  );
}
